import script from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=4ec7b13b&scoped=true&lang=scss"

import exportComponent from "/data/apps/fbe-location-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec7b13b"]])

export default __exports__